import { createActions, createReducer } from 'reduxsauce'

const listaPagos = [
    { value: '', label: 'Todas' },
    { value: 'S', label: 'Sim' },
    { value: 'N', label: 'Não' },
]

/**
 * Action types & creators
 */

export const { Types, Creators } = createActions({
    setExercicioConsultaOrdemCronologicaPagamento: ['exercicio'],
    setAdministracaoConsultaOrdemCronologicaPagamento: ['administracao'],
    setSituacaoConsultaOrdemCronologicaPagamento: ['situacao'],
    setPagosConsultaOrdemCronologicaPagamento: ['pagos'],
    setNomeCredorConsultaOrdemCronologicaPagamento: ['nomeCredor'],
    setCnpjConsultaOrdemCronologicaPagamento: ['cnpj'],
    setCpfConsultaOrdemCronologicaPagamento: ['cpf'],
    setDataVencimentoInicialConsultaOrdemCronologicaPagamento: ['dataVencimentoInicial'],
    setDataVencimentoFinalConsultaOrdemCronologicaPagamento: ['dataVencimentoFinal'],
    setDataPagamentoInicialConsultaOrdemCronologicaPagamento: ['dataPagamentoInicial'],
    setDataPagamentoFinalConsultaOrdemCronologicaPagamento: ['dataPagamentoFinal'],
    setDataDocumentoInicialConsultaOrdemCronologicaPagamento: ['dataDocumentoInicial'],
    setDataDocumentoFinalConsultaOrdemCronologicaPagamento: ['dataDocumentoFinal'],
    setValorLiquidacaoInicialConsultaOrdemCronologicaPagamento: ['valorLiquidacaoInicial'],
    setValorLiquidacaoFinalConsultaOrdemCronologicaPagamento: ['valorLiquidacaoFinal'],
    setDocumentoConsultaOrdemCronologicaPagamento: ['documento'],
    setSerieDocumentoConsultaOrdemCronologicaPagamento: ['serieDocumento'],
    setGruposConsultaOrdemCronologicaPagamento: ['grupos'],
    setRecursoConsultaOrdemCronologicaPagamento: ['recurso'],
    setDestinacaoConsultaOrdemCronologicaPagamento: ['destinacao'],
    setNumeroContratoConsultaOrdemCronologicaPagamento: ['numeroContrato'],
    setObjetoContratoConsultaOrdemCronologicaPagamento: ['objetoContrato'],
    limpaFiltroConsultaOrdemCronologicaPagamento: [],
    receberFiltroConsultaOrdemCronologicaPagamento: ['filtroRecebido'],
})

const INITIAL_STATE = {
    exercicio: new Date().getFullYear(),
    administracao: [],
    situacao: [],
    pagos: { value: listaPagos[0].value, label: listaPagos[0].label },
    nomeCredor: '',
    cnpj: '',
    cpf: '',
    dataVencimentoInicial: '',
    dataVencimentoFinal: '',
    dataPagamentoInicial: '',
    dataPagamentoFinal: '',
    dataDocumentoInicial: '',
    dataDocumentoFinal: '',
    valorLiquidacaoInicial: '',
    valorLiquidacaoFinal: '',
    documento: '',
    serieDocumento: '',
    grupos: [],
    recurso: [],
    destinacao: [],
    numeroContrato: '',
    objetoContrato: '',
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: action.situacao }
}

const setPagos = (state = INITIAL_STATE, action) => {
    return { ...state, pagos: action.pagos }
}
const setNomeCredor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeCredor: action.nomeCredor }
}
const setCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: action.cnpj }
}
const setCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: action.cpf }
}
const setDataVencimentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoInicial: action.dataVencimentoInicial }
}
const setDataVencimentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoFinal: action.dataVencimentoFinal }
}
const setDataPagamentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataPagamentoInicial: action.dataPagamentoInicial }
}
const setDataPagamentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataPagamentoFinal: action.dataPagamentoFinal }
}
const setDataDocumentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataDocumentoInicial: action.dataDocumentoInicial }
}
const setDataDocumentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataDocumentoFinal: action.dataDocumentoFinal }
}
const setValorLiquidacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, valorLiquidacaoInicial: action.valorLiquidacaoInicial }
}
const setValorLiquidacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, valorLiquidacaoFinal: action.valorLiquidacaoFinal }
}
const setDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, documento: action.documento }
}
const setSerieDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, serieDocumento: action.serieDocumento }
}
const setGrupos = (state = INITIAL_STATE, action) => {
    return { ...state, grupos: action.grupos }
}
const setRecurso = (state = INITIAL_STATE, action) => {
    return { ...state, recurso: action.recurso }
}
const setDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, destinacao: action.destinacao }
}
const setNumeroContrato = (state = INITIAL_STATE, action) => {
    return { ...state, numeroContrato: action.numeroContrato }
}
const setObjetoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, objetoContrato: action.objetoContrato }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setExercicio,
    [Types.SET_ADMINISTRACAO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setAdministracao,
    [Types.SET_SITUACAO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setSituacao,
    [Types.SET_PAGOS_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setPagos,
    [Types.SET_NOME_CREDOR_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setNomeCredor,
    [Types.SET_CNPJ_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setCnpj,
    [Types.SET_CPF_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setCpf,
    [Types.SET_DATA_VENCIMENTO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setDataVencimentoInicial,
    [Types.SET_DATA_VENCIMENTO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setDataVencimentoFinal,
    [Types.SET_DATA_PAGAMENTO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setDataPagamentoInicial,
    [Types.SET_DATA_PAGAMENTO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setDataPagamentoFinal,
    [Types.SET_DATA_DOCUMENTO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setDataDocumentoInicial,
    [Types.SET_DATA_DOCUMENTO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setDataDocumentoFinal,
    [Types.SET_VALOR_LIQUIDACAO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setValorLiquidacaoInicial,
    [Types.SET_VALOR_LIQUIDACAO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setValorLiquidacaoFinal,
    [Types.SET_DOCUMENTO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setDocumento,
    [Types.SET_SERIE_DOCUMENTO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setSerieDocumento,
    [Types.SET_GRUPOS_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setGrupos,
    [Types.SET_RECURSO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setRecurso,
    [Types.SET_DESTINACAO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setDestinacao,
    [Types.SET_NUMERO_CONTRATO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setNumeroContrato,
    [Types.SET_OBJETO_CONTRATO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setObjetoContrato,
    [Types.LIMPA_FILTRO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: receberFiltro,
})
